import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classes from "./TopHeader.scss";
import { colors } from "Constants";
import { ToddleIcon, LockScreenIcon, PreferencesIcon } from "SvgComponents";
import GradeFilter from "../GradeFilter";
import UIButton from "UIComponents/UIButton";
import Checkbox from "UIComponents/Checkbox";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import I18nHOC from "UIComponents/I18nHOC";
import DropzoneComponent from "UIComponents/DropzoneComponent";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import DialogueBox from "UIComponents/DialogueBox";
import BulkUploadErrorModal from "UIComponents/BulkUploadErrorModal";
import { isFeatureLocked } from "modules/PermissionModule";
import ACLStore from "lib/aclStore";
import { bulkUploadByFile } from "modules/Services";
import classNames from "classnames";
import { updateSnsSettingsAction } from "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule";
import { goToBack } from "modules/NavigationModule";
import {
  SegmentControl,
  Button,
  IconButton,
  Tooltip,
} from "@toddle-edu/ds-web";
import { disableEditForMapleBearChildOrg } from "Courses/modules/utils";
import { ChevronLeftOutlined, CloseOutlined } from "@toddle-edu/ds-icons";
import { getIsPreviousAcademicYearSelected } from "modules/CommonSelectors";

import ConditionalWrapper from "Utils/ConditionalWrapper";

const BULK_UPLOAD_BUTTONS = t => [
  // {
  //   label: t("common:import_label", { label: t("common:benchmarks_label") }),
  //   type: "BENCHMARK",
  //   perm: "AdminPortal:SnSBulkUpload"
  // }
];
const DIALOGS_INFO = {
  RECONFIGURE: {
    title: ({ t }) =>
      t("scopeAndSequence:reconfigure") +
      " " +
      t("scopeAndSequence:scope_and_sequence"),
    message: ({ t }) => {
      return (
        <div>
          <div
            style={{ color: `${colors.jaguar}`, margin: "0px 0px 24px 0px" }}
          >
            {t("scopeAndSequence:reconfigure_warning_msg")}
          </div>
          <div
            style={{ color: `${colors.yellow500}`, margin: "0px 0px 24px 0px" }}
          >
            {t("scopeAndSequence:reconfigure_warning_msg_desc")}
          </div>
        </div>
      );
    },
    confirmButtonText: ({ t }) => t("common:remove"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    dialogContentClass: classes.dialogBoxContent,
  },
};
DIALOGS_INFO.RECONFIGURE.message.displayName = "RECONFIGURE_SNS";
class TopHeader extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      benchmarkBulkUploadErrorModal: false,
      errors: [],
      dailogueState: "",
    };
  }

  onChangeMode = () => {
    const { mode, onChangeMode } = this.props;
    onChangeMode(mode == "edit" ? "view" : "edit");
  };

  onContentUploaded = async ({ data, type }) => {
    const { successful, errors } = await this.props.bulkUploadByFile({
      url: data.url,
      type,
    });
    if (!successful) {
      this.setState({
        errors: errors,
      });
      this.toggleBulkUploadErrorModal();
    }
  };

  toggleBulkUploadErrorModal = () => {
    this.setState({
      benchmarkBulkUploadErrorModal: !this.state.benchmarkBulkUploadErrorModal,
    });
  };
  renderMenuItems = () => {
    const { t } = this.props;
    const MENU_ITEMS = [
      {
        label: t("scopeAndSequence:reconfigure_standards"),
        value: "RECONFIGURE",
      },
      {
        label: t("scopeAndSequence:rename_hierarchy_levels"),
        value: "EDIT_HIERARCHY",
      },
    ];

    if (ACLStore.can("AdminPortal:SnSAppendBulkUpload"))
      MENU_ITEMS.push({
        label: t("scopeAndSequence:append_standards"),
        value: "APPEND",
      });
    return MENU_ITEMS;
  };

  onSettingsItemClick = value => {
    if (value === "RECONFIGURE") {
      this.setState({ dailogueState: value });
    } else if (value === "APPEND") {
      this.props.updateSnsSettingsAction(value);
      this.props.goToBack();
    } else {
      this.props.updateSnsSettingsAction(value);
      this.props.goToBack();
    }
  };
  toggleDialogueBoxDisplay = () => {
    this.setState({
      dailogueState: "",
    });
  };
  onDialogConfirmClick = () => {
    const { dailogueState } = this.state;
    this.props.updateSnsSettingsAction(dailogueState);
    this.props.goToBack();
  };

  onChangeTab = param => {
    const { tabs, changeTab } = this.props;
    changeTab(_.find(tabs, { value: param }));
  };

  render() {
    const {
      t,
      tabs,
      currentTab,
      changeTab,
      title,
      subTitle,
      onBackClick,
      mode,
      grades,
      gradeFilters,
      updateGradeFilters,
      isAdmin,
      isTagging,
      onSaveClick,
      showNodeTree,
      description,
      editRootNode,
      onConceptualUnderStandingCheckBoxClick,
      showDetails,
      isSetPreview,
      onClickChoose,
      showEditButton = true,
      disableEditButton = false,
      showBackButton = true,
      enableBreadCrumbs = true,
      loginActiveTab,
      isDsComponent = false,
      onCloseModal = () => {},
      showSaveAndExitButton = true,
      isPreviousAcademicYearSelected,
      areOperationsDisabledForLocalisation,
      getDisabledOperationTooltip,
      testId,
      shouldBypassDisable = false,
    } = this.props;
    const tabsLength = _.get(tabs, "length", 0);
    const isLocked = isFeatureLocked("SNS_EDITOR");

    const { dailogueState } = this.state;
    const isSchoolOnboardingTab = loginActiveTab == "school-onboarding";

    const titleTextClass = classNames({
      [classes.titleText]: !isDsComponent,
      [classes.titleTextV2]: isDsComponent,
    });

    const shouldDisableEditButton =
      disableEditButton ||
      isPreviousAcademicYearSelected ||
      areOperationsDisabledForLocalisation;

    return (
      <>
        {dailogueState && (
          <DialogueBox
            customModalContentClass={
              DIALOGS_INFO[dailogueState].dialogContentClass
            }
            modalTitle={DIALOGS_INFO[dailogueState].title({ t })}
            onClickButton2={this.onDialogConfirmClick}
            modalBody={DIALOGS_INFO[dailogueState].message({
              t,
            })}
            toggleDialogueBoxDisplay={this.toggleDialogueBoxDisplay}
            button1={DIALOGS_INFO[dailogueState].cancelButtonText({ t })}
            button2={DIALOGS_INFO[dailogueState].confirmButtonText({ t })}
          />
        )}
        <div
          className={isDsComponent ? classes.containerV2 : classes.container}
        >
          <div
            className={
              isDsComponent ? classes.leftContainerV2 : classes.leftContainer
            }
          >
            {showBackButton ? (
              <div className={classes.logoContainer}>
                <div className={classes.chevronIconContainer}>
                  <IconButton
                    variant={"plain"}
                    icon={<ChevronLeftOutlined />}
                    onClick={onBackClick}
                    testId={`${testId}-back`}
                  />
                </div>
                <ToddleIcon width="32px" height="32px" />
              </div>
            ) : null}
            <div className={classes.textAndAttributionContainer}>
              <div className={classes.textContainer}>
                <div className={titleTextClass}>{title}</div>
                {!_.isEmpty(subTitle) && (
                  <div className={classes.subTitleText}>{subTitle}</div>
                )}
              </div>
              {!!description && (
                <LinkWithTooltip placement="top" tooltip={description}>
                  <div className={classes.descriptionText}>{description}</div>
                </LinkWithTooltip>
              )}
            </div>
          </div>
          <div className={classes.rightContainer}>
            {tabsLength > 1 && mode == "edit" && !showNodeTree && (
              <SegmentControl
                options={tabs}
                value={currentTab}
                onChange={this.onChangeTab}
              />
            )}
          </div>
          <div className={classes.buttonsContainer}>
            {mode == "edit" && showNodeTree && showDetails && (
              <div
                className={classes.checkBoxContainer}
                onClick={onConceptualUnderStandingCheckBoxClick}
              >
                <Checkbox
                  isChecked={_.includes(
                    _.get(editRootNode, "snsChildren", []),
                    "CONCEPTUAL_UNDERSTANDING"
                  )}
                  label={t("common:enable_with_label", {
                    label: t("academicSetup:cu"),
                  })}
                  testId={testId}
                />
              </div>
            )}
            {mode == "view" && !showNodeTree && !isDsComponent && (
              <GradeFilter
                label={t("common:filter_by_label", {
                  label: t("common:label_with_colon", {
                    label: t("common:grade_plural"),
                  }),
                })}
                grades={grades}
                gradeFilters={gradeFilters}
                updateGradeFilters={updateGradeFilters}
              />
            )}
            {isTagging && showSaveAndExitButton && (
              <Button
                variant={"progressive"}
                onClick={() => onSaveClick({ shouldCloseModal: true })}
                testId={`${testId}-save-exit`}
              >
                {t("common:save_exit")}
              </Button>
            )}

            {isDsComponent && (
              <div className={classes.closeIcon}>
                <IconButton
                  icon={<CloseOutlined />}
                  size={"medium"}
                  variant={"plain"}
                  onClick={onCloseModal}
                  testId={`${testId}-close`}
                />
              </div>
            )}

            {isSchoolOnboardingTab && showEditButton && !isSetPreview && (
              <div
                id={"COACHMARKS_SCOPE_SEQUENCE_EDITOR_PREFERENCES_BUTTON"}
                className={classes.preferencesContainer}
              >
                <ButtonDropdown
                  authTabs={this.renderMenuItems()}
                  buttonComponent={<PreferencesIcon />}
                  onItemClick={this.onSettingsItemClick}
                />
              </div>
            )}
            {isTagging ||
              (showNodeTree && mode == "edit" && (
                <UIButton
                  size={"sm"}
                  type={"filled"}
                  color={"pink"}
                  onClick={() => onSaveClick({ shouldCloseModal: true })}
                  isDisabled={!showDetails && showNodeTree && mode == "edit"}
                >
                  {t("common:save_exit")}
                </UIButton>
              ))}
            {isAdmin &&
              (!showNodeTree || mode == "view") &&
              !isTagging &&
              !isSetPreview && (
                <div className={classes.buttonContainer}>
                  {_.map(BULK_UPLOAD_BUTTONS(t), ({ label, type, perm }) => {
                    const isEnabled = ACLStore.can(perm);
                    return (
                      isEnabled && (
                        <DropzoneComponent
                          key={type}
                          multiple={false}
                          renderComponent={
                            <UIButton color={"pink"} size={"lg"}>
                              {label}
                            </UIButton>
                          }
                          accept={[".csv", "text/csv"]}
                          onSingleContentUploaded={data =>
                            this.onContentUploaded({ data, type })
                          }
                        />
                      )
                    );
                  })}

                  {this.state.benchmarkBulkUploadErrorModal ? (
                    <BulkUploadErrorModal
                      toggleBulkUploadErrorModal={
                        this.toggleBulkUploadErrorModal
                      }
                      errors={this.state.errors}
                    />
                  ) : null}

                  {showEditButton &&
                    !disableEditForMapleBearChildOrg({
                      shouldBypassDisable: shouldBypassDisable,
                    }) && (
                      <ConditionalWrapper
                        type={"wrapperAsElement"}
                        condition={
                          isPreviousAcademicYearSelected ||
                          areOperationsDisabledForLocalisation
                        }
                        wrapper={
                          <Tooltip
                            tooltip={getDisabledOperationTooltip({
                              datasetName: subTitle,
                              operationLabel: t("common:modify"),
                              t,
                            })}
                          />
                        }
                      >
                        <div>
                          <UIButton
                            size={"sm"}
                            type={"hollow"}
                            color={"pink"}
                            onClick={this.onChangeMode}
                            isDisabled={shouldDisableEditButton}
                          >
                            <div className={classes.editButton}>
                              <div className={classes.editText}>
                                {mode == "edit"
                                  ? t("common:view")
                                  : t("common:modify")}
                              </div>

                              {isLocked && (
                                <div className={classes.lockIcon}>
                                  <LockScreenIcon height={14} width={14} />
                                </div>
                              )}
                            </div>
                          </UIButton>
                        </div>
                      </ConditionalWrapper>
                    )}
                </div>
              )}
            {isSetPreview && (
              <UIButton size={"sm"} color={"pink"} onClick={onClickChoose}>
                {t("common:choose")}
              </UIButton>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapActionCreators = {
  bulkUploadByFile,
  updateSnsSettingsAction,
  goToBack,
};
const mapStateToProps = (state, ownProps) => {
  const { activeTab } = state.login;

  const isPreviousAcademicYearSelected = getIsPreviousAcademicYearSelected(
    state
  );
  return {
    loginActiveTab: activeTab,
    isPreviousAcademicYearSelected,
  };
};
export default compose(
  I18nHOC({ resource: ["common", "academicSetup"] }),
  connect(mapStateToProps, mapActionCreators)
)(TopHeader);

TopHeader.defaultProps = {
  hideBackButton: false,
};
